import { Mapper } from "../../../../base/utils/mapper";
import { PrepaidMedicineModel } from "../../../../domain/models/configuration/prepaid-medicinal.model";
import { PrepaidMedicineEntity } from "../entities/prepaid-medicine.entity";

export class PrepaidMedicineImplementationRepositoryMapper extends Mapper<PrepaidMedicineEntity, PrepaidMedicineModel> {
    mapFrom(param: PrepaidMedicineEntity): PrepaidMedicineModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: PrepaidMedicineModel): PrepaidMedicineEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}